import React, { Component } from "react";

import { ReactComponent as Address } from "../../assests/images/web3_nft.svg";

export default class DesignImg extends Component {
  render() {
    return <Address />;
  }
}
